import Cookies from "js-cookie";
import { useQuery } from 'react-query';
export const useSubscription = () =>{
    const users = Cookies.get('token')
    const getSubs = async() =>{

        
        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/subscription`, {
            method: 'GET',
            headers: {'Content-Type':'application/json', 
            'Authorization': `Bearer ${users}`
        }
        
        })
       
        const json = await response.json()
            if(response.status === 200){
               
                return json
            
            }
          
    
    }

    // return {getSubs}

const {data} = useQuery(
    "subscription",
    getSubs,
    
  )

  const subsInfo = data

    return {subsInfo}
}